// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3ValE","overflowing":"ReadFullNote_overflowing__2pjIg"};